module.exports = __webpack_public_path__ + "img/sidebar-default.cdd48b1.webp";